import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
import Button from "../../components/Button/Button"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import {
   Container,
   Wrapper,
   Message,
   Form,
   Title,
   Input,
} from "./ResetPassword.styles"

const ResetPassword = () => {
   const navigate = useNavigate()
   const { t } = useTranslation()
   const { userId, userEmail, token } = useParams()
   const [message, setMessage] = useState(null)
   const [password, setPassword] = useState("")
   const [confirmation, setConfirmation] = useState("")
   const [email, setEmail] = useState("")
   const [isFetching, setIsFetching] = useState(false)

   const handleSubmitEmail = async (e) => {
      e.preventDefault()
      setIsFetching(true)
      try {
         await publicRequest.post("/auth/demandReset", { email })
         setMessage(t("resetPasswordPage.message.m1"))
      } catch (err) {
         setMessage(err.message)
         setIsFetching(false)
      }
   }

   const handleSubmitPassword = async (e) => {
      e.preventDefault()
      setIsFetching(true)
      try {
         await publicRequest.post("/auth/performReset", {
            userId,
            email: userEmail,
            token,
            password,
         })
         setMessage(t("resetPasswordPage.message.m2"))
         setTimeout(() => navigate("/login"), 4000)
      } catch (err) {
         setMessage(err.message)
         setIsFetching(false)
      }
   }

   useEffect(() => {
      if (password !== confirmation && confirmation !== "") {
         setMessage(t("resetPasswordPage.message.m3"))
      } else if (
         (!email.includes("@") || !email.includes(".")) &&
         email !== ""
      ) {
         setMessage(t("resetPasswordPage.message.m4"))
      } else {
         setMessage(null)
      }
   }, [email, password, confirmation, t])

   return (
      <>
         <Helmet>
            <title>{t("resetPasswordPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               <Form>
                  <Title>{t("resetPasswordPage.title.t1")}</Title>
                  {token === "noToken" ? (
                     <>
                        <Input
                           placeholder={t("resetPasswordPage.input.i1")}
                           type="text"
                           onChange={(e) => setEmail(e.target.value)}
                        />
                        {message && <Message>{message}</Message>}
                        <Button
                           text={t("resetPasswordPage.button.b1")}
                           callback={(e) => handleSubmitEmail(e)}
                           disabled={isFetching || message !== null}
                           submit
                        />
                     </>
                  ) : (
                     <>
                        <Input
                           placeholder={t("resetPasswordPage.input.i2")}
                           type="password"
                           onChange={(e) => setPassword(e.target.value)}
                        />
                        <Input
                           placeholder={t("resetPasswordPage.input.i3")}
                           type="password"
                           onChange={(e) => setConfirmation(e.target.value)}
                        />
                        {message && <Message>{message}</Message>}
                        <Button
                           text={t("resetPasswordPage.button.b2")}
                           callback={(e) => handleSubmitPassword(e)}
                           disabled={isFetching || message !== null}
                           submit
                        />
                     </>
                  )}
               </Form>
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default ResetPassword
